var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lazy-image', { loaded: _vm.loaded }]},[_c('img',{staticClass:"lazy-image__from",attrs:{"src":_vm.from}}),_vm._v(" "),_c('img',{ref:"loadedEl",staticClass:"lazy-image__to",attrs:{"src":_vm.toLoad}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40fc79db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/lazyload/LazyImage.vue
// module id = null
// module chunks = 